import React from 'react';
import {useNavigate} from "react-router-dom";
import {OrderType} from "../../../../services/Api/types";
import OrderTypeIcon from "../../../../components/Common/OrderTypeIcon";
import {useTranslation} from "react-i18next";
import {ReactComponent as ArrowRightIco} from "../../../../../images/icons/arrow-right.svg";
import {SessionState} from "../../../../services/Session/types";

interface Props {
    link: string;
    orderType: OrderType;
    session: SessionState;
    setShowAddressModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const MultistoreOrderTypesModalElement = ({link, orderType, session, setShowAddressModal}: Props) => {
    const navigate = useNavigate();
    const {t} = useTranslation();

    const handleClick = () => {
        if(orderType === OrderType.DELIVERY && !session.full_address) {
            setShowAddressModal(true);
            return;
        }
        navigate(`${link}/${orderType}`);
    }

    return (
        <button onClick={handleClick} className="btn btn-lg btn-default btn-nav w-100">
            <OrderTypeIcon orderType={orderType}/>
            <h1 className="h6 mb-0">
                {t(`enums.order.type.${orderType}`)}
            </h1>
            <ArrowRightIco/>
        </button>
    )
}

export default MultistoreOrderTypesModalElement;